// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__OD_CJ","log":"ModalInventoryLogs_log__2FnA8","date":"ModalInventoryLogs_date__3iZ-8","userName":"ModalInventoryLogs_userName__2tL2I"};